<template>
  <div class="s1-dd" v-click-outside="close">
    <!-- Approve / Cancel header -->
    <div class="s1-dd-header" v-if="!noShiftChosen">
      <button
        class="s1-dd-btn s1-dd-approve"
        v-if="shiftStatus === undefined && shift.choice_id !== 4"
        @click="approveShift"
      >
        <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
        Approve
      </button>
      <button
        class="s1-dd-btn s1-dd-cancel"
        v-if="shiftStatus !== undefined && shift.choice_id !== 4"
        @click="cancelShiftApproval"
      >
        <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        Cancel approval
      </button>
    </div>

    <div class="s1-dd-divider" v-if="shift.choice_id !== 4 && !noShiftChosen">Change to</div>
    <div class="s1-dd-divider" v-if="shift.choice_id === 4 && !noShiftChosen">Select shift</div>
    <div class="s1-dd-divider" v-if="noShiftChosen">Assign shift</div>

    <!-- Shift options -->
    <div
      v-for="s in activeChoices"
      :key="s.id"
      class="s1-dd-option"
      :class="'s1-dd-opt-' + shiftColor(s.id)"
      @click="changeShift(s.id)"
    >
      <span class="s1-dd-opt-badge">{{ shiftShort(s.id) }}</span>
      <span class="s1-dd-opt-name">{{ s.name }}</span>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "Shifts1Dropdown",
  directives: { clickOutside: vClickOutside.directive },
  props: {
    shift:       { type: Object, required: true },
    shiftStatus: { type: String, default: undefined },
    isFriday:    { type: Boolean, default: false },
    noShiftChosen: { type: Object, default: null },
    userStrength: { type: Array, default: () => [] },
  },

  data() {
    return {
      regularChoices: [
        { id: 1, name: "MORNING  09:00-17:00" },
        { id: 2, name: "NOON  12:00-20:00" },
        { id: 3, name: "EVENING  15:00-23:00" },
        { id: 4, name: "Any" },
        { id: 6, name: "VACATION" },
        { id: 8, name: "ILLNESS" },
      ],
      fridayChoices: [
        { id: 1, name: "MORNING  09:00-16:00" },
        { id: 2, name: "NOON  11:00-18:00" },
        { id: 3, name: "EVENING  14:00-21:00" },
        { id: 4, name: "Any" },
        { id: 6, name: "VACATION" },
        { id: 7, name: "CUSTOM" },
        { id: 8, name: "ILLNESS" },
      ],
      noAnyChoices: [
        { id: 1, name: "MORNING  09:00-17:00" },
        { id: 2, name: "NOON  12:00-20:00" },
        { id: 3, name: "EVENING  15:00-23:00" },
        { id: 6, name: "VACATION" },
        { id: 8, name: "ILLNESS" },
      ],
    };
  },

  computed: {
    activeChoices() {
      if (this.shift.choice_id === 4) {
        return this.isFriday
          ? this.fridayChoices.filter(c => c.id !== 4)
          : this.noAnyChoices;
      }
      return this.isFriday ? this.fridayChoices : this.regularChoices;
    }
  },

  methods: {
    close() { this.$emit("closeDropdown"); },

    async approveShift() {
      await apiClientCreator(`shifts/approve_user_choice/${this.shift.id}`).post("", {});
      this.$emit("closeDropdown");
    },

    async cancelShiftApproval() {
      await apiClientCreator(`shifts/cancel_shift_approval/${this.shift.id}`).post("", {});
      this.$emit("closeDropdown");
    },

    async changeShift(choiceId) {
      if (this.noShiftChosen) {
        await apiClientCreator("shifts/select_user_choice").post("", {
          user_id:   this.noShiftChosen.user_id,
          choice_id: choiceId,
          day:       this.noShiftChosen.day,
        });
      } else {
        await apiClientCreator(`shifts/change_user_choice/${this.shift.id}`).post("", {
          choice_id: choiceId,
        });
      }
      this.$emit("closeDropdown");
    },

    shiftShort(id) {
      return { 1:"MOR", 2:"NOO", 3:"EVE", 4:"ANY", 6:"VAC", 7:"CUS", 8:"ILL" }[id] || "?";
    },

    shiftColor(id) {
      return { 1:"dp", 2:"sc", 3:"rf", 4:"ac", 6:"tr", 7:"bn", 8:"na" }[id] || "na";
    },
  }
};
</script>

<style scoped>
.s1-dd {
  position: absolute;
  z-index: 500;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: var(--c1-card);
  border: 1px solid var(--c1-brd);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,.12);
  min-width: 180px;
  padding: 6px 0;
  font-size: 12px;
}

.s1-dd-header {
  display: flex; gap: 6px;
  padding: 6px 10px 2px;
}

.s1-dd-btn {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 10px; border-radius: 5px;
  font-size: 11px; font-weight: 600; cursor: pointer;
  border: 1px solid;
  transition: all .12s;
}
.s1-dd-btn svg { width: 11px; height: 11px; stroke: currentColor; fill: none; stroke-width: 2.5; }

.s1-dd-approve {
  background: #EDFAF2; color: #1a7a45; border-color: var(--c1-ac);
}
.s1-dd-approve:hover { background: var(--c1-ac); color: #fff; }

.s1-dd-cancel {
  background: #FFF0F0; color: #7a2020; border-color: var(--c1-rf);
}
.s1-dd-cancel:hover { background: var(--c1-rf); color: #fff; }

.s1-dd-divider {
  font-size: 9px; font-weight: 700;
  text-transform: uppercase; letter-spacing: .5px;
  color: var(--c1-t3);
  padding: 6px 12px 4px;
  border-top: 1px solid var(--c1-brd-l);
  margin-top: 4px;
}

.s1-dd-option {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background .1s;
}
.s1-dd-option:hover { background: var(--c1-act); }

.s1-dd-opt-badge {
  font-family: 'JetBrains Mono', monospace;
  font-size: 9px; font-weight: 700;
  padding: 2px 5px; border-radius: 3px;
  min-width: 30px; text-align: center;
}
.s1-dd-opt-dp .s1-dd-opt-badge { background: #F0ECFF; color: var(--c1-dp); }
.s1-dd-opt-sc .s1-dd-opt-badge { background: #FFF4E8; color: #854F0B; }
.s1-dd-opt-rf .s1-dd-opt-badge { background: #FFF0F0; color: #7a2020; }
.s1-dd-opt-ac .s1-dd-opt-badge { background: #EDFAF2; color: #1a7a45; }
.s1-dd-opt-tr .s1-dd-opt-badge { background: #F0F4FF; color: #3A5BAD; }
.s1-dd-opt-bn .s1-dd-opt-badge { background: #F5F3F0; color: var(--c1-t2); }
.s1-dd-opt-na .s1-dd-opt-badge { background: #F5F3F0; color: var(--c1-t2); }

.s1-dd-opt-name { font-size: 11px; color: var(--c1-t1); font-weight: 500; }
</style>
